<template>
    <div>
        <div :class=" bgColor == 'gray' ? ' contact-container bg-gray' : 'contact-container' " v-if="showContact">
            <div class="contact-warp">
                <div class="contact">
                    <p>
                        <i class="iconfont icon-lianjieguanwang"></i>
                        <span>{{$t('signIn.egateeWebsite')}}{{$t('base.colon')}}&nbsp;&nbsp;</span> <a href="https://egatee.com/en" target="_blank">{{$t('signIn.aboutUs')}}</a>
                    </p>
                    <p>
                        <i class="iconfont icon-youxiang"></i>
                        <span>{{$t('signIn.suggestion')}}{{$t('base.colon')}}&nbsp;&nbsp;</span> egateevoice@gmail.com
                    </p>
                    <p>
                        <i class="iconfont icon-dianhua"></i>
                        <span>{{$t('signIn.china')}}{{$t('base.colon')}}&nbsp;</span> 15961709232
                        <span class="ml20">{{$t('signIn.CoteDivoire')}}{{$t('base.colon')}}&nbsp;</span> Orange 67075145
                        <span class="ml20">{{$t('signIn.uganda')}}{{$t('base.colon')}}&nbsp;</span> MTN 0393000555 / Airtel 0200955005
                    </p>
                </div>
                <div class="download">
                    <div>
                        <img src="../../assets/egatee_logo.png" alt="Egatee app logo">
                        <div>
                            <p v-if="isIOS()">
                                <el-popover
                                    placement="top"
                                    width="360"
                                    trigger="click">
                                    <el-row :gutter="10" class="egatee_ios_download_qr">
                                        <el-col :span="11">
                                            <div class="left-qr">
                                                <img src="../../assets/egatee_ios_download_qr.png" alt="egatee ios download qr code">
                                            </div>
                                        </el-col>
                                        <el-col :span="13">
                                            <div class="right-main">
                                                <div class="right-title">{{ $t('signIn.scanQrCode') }}</div>
                                                <div class="right-content">{{$t('signIn.downloadBuyerApp')}}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <!-- <el-button slot="reference">click 激活</el-button> -->
                                    <a slot="reference" :href="egateeApkurl">{{$t('signIn.downloadAPP',['Egatee'])}}</a>
                                </el-popover>
                            </p>
                            <p v-else><a :href="egateeApkurl">{{$t('signIn.downloadAPP',['Egatee'])}}</a></p>
                            <p v-if="isIOS()"><a :href="'https://apps.apple.com/us/app/egatee/id6472037628'" target="_blank">{{$t('signIn.downloadAppOnAppStore',['Egatee'])}}</a></p>
                            <p v-else><a :href="'https://play.google.com/store/apps/details?id='+egateeGPid" target="_blank">{{$t('signIn.downloadAppOnGP',['Egatee'])}}</a></p>
                        </div>
                    </div>
                    <div>
                        <img src="../../assets/JDE_logo_gray.png" alt="Jde app logo">
                        <div>
                            <p><a :href="jdeApkurl" @click="downloadJdeIosTips">{{$t('signIn.downloadAPP',['JDE'])}}</a></p>
                            <p><a :href="'https://play.google.com/store/apps/details?id='+jdeGPid" target="_blank">{{$t('signIn.downloadAppOnGP',['JDE'])}}</a></p>
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="bottom w-warp">
            <div class="footer-1">
                ©Egatee {{currentYear}}.All Rights Reserved.
            </div>
        </div>
    </div>
</template>

<script>
import { logout } from "@/api";
import { removeToken } from "@/auth";
import { isIOS } from "@/utils/env.js";
export default {
    name: "foot",
    data() {
        return {
            egateeGPid: "com.egatee.store",
            jdeGPid: "com.egatee.jde",
            locationHost: window.location.host,
            currentYear: ''
        };
    },
    props: {
        showContact: {
            type: Boolean,
            default: false,
        },
        bgColor: {
            type: String,
            default: "",
        },
    },
    components: {},
    mounted() {
        this.getNewYear()
    },
    computed: {
        egateeApkurl() {
            // IOS
            if(this.isIOS()) {
                return "javascript:;"
            }

            // Android
            if (this.locationHost == "passport.egatee.com") {
                return "https://res.egatee.com/apk_path/egatee.apk";
            } else {
                return "https://res.uat.egatee.net/apk_path/egatee.apk";
            }
        },
        jdeApkurl() {
            // IOS
            if(this.isIOS()) {
                return `javascript:;`
            }
            if (this.locationHost == "passport.egatee.com") {
                return "https://res.egatee.com/apk_path/jde.apk";
            } else {
                return "https://res.uat.egatee.net/apk_path/jde.apk";
            }
        },
    },
    methods: {
        isIOS,
        downloadJdeIosTips() {
            if(this.isIOS()) {
                this.$message({
                    message: this.$t('signIn.iosDownloadIsNotCurrentlySupportedSoStayTuned', ['JDE']),
                    type: "warning",
                });
                return;
            }
        },
        logout() {
            logout().then((res) => {
                removeToken();
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                this.$router.push({ path: "/login" });
                console.log(res);
            });
        },
        getNewYear() {
            this.currentYear = new Date().getFullYear()
        }
    },
};
</script>

<style lang="scss" scoped>
.ml20 {
    margin-left: 20px;
}

/*foorter*/
.bg-gray {
    background-color: #f5f6f8;
}
.contact-container {
    cursor: default;
    width: 100%;
    min-width: 1200px;
    padding: 28px 0;
    font-family: "PingFang-SC-Medium";
    font-size: 12px;

    .contact-warp {
        width: 1200px;
        // height: 180px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .contact {
            color: #958c8d;
            i {
                font-size: 18px;
                margin-right: 13px;
            }
        }

        .download {
            text-align: left;

            & > div:first-child {
                margin-bottom: 20px;
            }

            & > div {
                display: flex;
                align-items: center;
                img {
                    width: 48px;
                    height: 48px;
                    margin-right: 13px;
                }
                span {
                    margin: 0;
                }
            }

            & > div > div > p {
                margin: 0;
            }

            & > div > div > p:first-child {
                margin-bottom: 8px;
            }
        }

        p {
            text-align: left;
            margin-bottom: 8px;
            display: flex;
            span {
                color: #000;
                display: inline-block;
            }
        }

    }
}

.w-warp {
    cursor: default;
    font-size: 12px;
    width: 1200px;
    height: 93px;
    margin: 0 auto;
}

.footer-1 {
    font-family: MicrosoftYaHei;
    cursor: default;
    font-size: 12px;
    color: #999;
    border-top: 1px solid #f2f2f2;
    font-size: 12px;
    text-align: center;
    padding-top: 20px;
}

a:link {
    color: #4285f4;
    text-decoration: none;
}
a:visited {
    color: #4285f4;
    text-decoration: none;
}
a:hover {
    color: #4285f4;
    text-decoration: none;
}
a:active {
    color: #4285f4;
    text-decoration: none;
}

.egatee_ios_download_qr {
    .left-qr {
        width: 150px;
        height: 150px;
        margin: 10px 0px 10px 10px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .right-main {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 170px;
        .right-title {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 5px;
        }
        .right-content {
            font-size: 20px;
            font-weight: bold;
        }
    }
}
</style>